import * as S from '../styled'
import WhatsAppPhone from './WhatsAppPhone'

const WhatsAppMessage = () => (
    <S.Message>
      Clique aqui, <S.BuyWithWhatsApp>compre pelo WhatsApp </S.BuyWithWhatsApp>e
      receba em casa
      <WhatsAppPhone />
    </S.Message>
)

export default WhatsAppMessage
